import type { MenuConfig } from '~typings/menu'

import configuracion from './configuracion'
import informes from './informe'
import mantenimiento from './mantenimiento'
import transacciones from './transacciones'
import permisos, { RESOURCE_CUENTAS_X_COBRAR } from '@/auth/permissions/modules/cuentasXCobrarPg'

const menuList: MenuConfig[] = [
    {
        title: 'cuentas_x_cobrar.menu_title',
        fontIcon: 'calculator',
        resource: RESOURCE_CUENTAS_X_COBRAR,
        action: permisos._root,
        children: [
            {
                title: 'global.menu.mantenimiento',
                icon: 'EditIcon',
                resource: RESOURCE_CUENTAS_X_COBRAR,
                action: permisos.mantenimiento._perm,
                children: mantenimiento,
            },
            {
                title: 'global.menu.configuracion',
                icon: 'SettingsIcon',
                action: permisos.configuracion._perm,
                resource: RESOURCE_CUENTAS_X_COBRAR,
                children: configuracion,
            },
            {
                title: 'global.menu.transacciones',
                fontIcon: 'exchange-alt',
                action: permisos.transacciones._perm,
                resource: RESOURCE_CUENTAS_X_COBRAR,
                children: transacciones,
            },
            {
                title: 'global.menu.informes',
                fontIcon: 'file-prescription',
                action: permisos.informes._perm,
                resource: RESOURCE_CUENTAS_X_COBRAR,
                children: informes,
            },
        ],
    },
]

export default menuList
